export let withoutReqPdt = {
    "statuscode":"OK",
    "messagetype":" ",
    "statusmessage":"OK",
    "result": [
        {
            "result_text":"U hoeft voor dit voertuig geen ontheffing te hebben voor toegang tot een milieuzone.",
            "request_product_button":"N"
        }
    ]
}

export let withReqPdt = {
    "statuscode":"OK",
    "messagetype":" ",
    "statusmessage":"OK",
    "result": [
        {
            "result_text":"U heeft voor dit voertuig een ontheffing nodig voor toegang tot een milieuzone.",
            "request_product_button":"Y"
        }
    ]
}

export let data3 = {
    "licenseplate":"BSRV51"
    ,"need_exemption":true
    ,"controle":"U heeft voor uw voertuig een ontheffing nodig om de milieuzone in te mogen"
    ,"rvo":"Uw voertuig heeft geen ontheffing voor een groene milieuzone voor vrachtauto\u0027s Uw voertuig is 13 jaar oud geworden en heeft geen toegang meer tot de milieuzones voor vrachtauto \u0027s. Wel kan voor dit voertuig een dagontheffing worden aangevraagd bij de gemeente die de betreffende milieuzone heeft ingesteld."
    ,"npr":"Er kan momenteel geen informatie opgehaald worden over locale ontheffingen.Area manager does not exist or is not valid"
    }

export let data4 = {
        "licenseplate":"000000" //bsgb71
        ,"need_exemption":true
        ,"controle":"U heeft voor uw voertuig een ontheffing nodig om de milieuzone in te mogen"
        ,"rvo":"Uw voertuig heeft geen ontheffing voor een groene milieuzone voor vrachtauto\u0027s"
        ,"rvodetails":"Uw voertuig is 13 jaar oud geworden en heeft geen toegang meer tot de milieuzones voor vrachtauto\u0027s. Wel kan voor dit voertuig een dagontheffing worden aangevraagd bij de gemeente die de betreffende milieuzone heeft ingesteld."
        ,"npr":"Er zijn geen locale ontheffingen voor dit voertuig."
}
